import { render, staticRenderFns } from "./AditarItem.vue?vue&type=template&id=fe8a79ae&scoped=true"
import script from "./AditarItem.vue?vue&type=script&lang=js"
export * from "./AditarItem.vue?vue&type=script&lang=js"
import style0 from "./AditarItem.vue?vue&type=style&index=0&id=fe8a79ae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8a79ae",
  null
  
)

export default component.exports